import React from 'react';
import { sortBy, prop } from 'ramda';
import { useGetAllHazardsForShareSuspense, useGetAllElementTypesForShareSuspense, useGetAllActionTypesForShareSuspense, } from '../../../../../services/api/generated/client';
import { unwrapModel } from '../../../../../services/api/unwrapModel';
import EditFindingForm from '../EditFindingForm';
import { useInspectionDetailShareContext } from '../../../../pages/upgrade/InspectionDetail/ShareInspection/InspectionDetailShareProvider';
const EditFindingFormShareWrapper = ({ onClose }) => {
    const { token } = useInspectionDetailShareContext();
    const { data: hazardsResponse } = useGetAllHazardsForShareSuspense(token, {
        query: { staleTime: Infinity, refetchOnMount: false },
    });
    const { data: elementsResponse } = useGetAllElementTypesForShareSuspense(token, {
        query: { staleTime: Infinity, refetchOnMount: false },
    });
    const { data: actionTypesResponse } = useGetAllActionTypesForShareSuspense(token, {
        query: { staleTime: Infinity, refetchOnMount: false },
    });
    const availableHazards = unwrapModel(hazardsResponse);
    const availableElements = unwrapModel(elementsResponse);
    const availableActionTypes = unwrapModel(actionTypesResponse);
    if (!availableHazards || !availableElements || !availableActionTypes)
        return null;
    const sortedElements = sortBy(prop('name'), availableElements);
    return (React.createElement(EditFindingForm, { canEdit: false, onClose: onClose, availableElements: sortedElements, availableHazards: availableHazards, availableActionTypes: availableActionTypes }));
};
export default EditFindingFormShareWrapper;
